import { useTranslation } from "react-i18next";
import TextInput from "../../inputs/textInput";

const Step1Form = ({ formik }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <TextInput
        formik={formik}
        placeholder={t("companyName")}
        label={t("companyName")}
        name={"companyName"}
      />
      <TextInput
        formik={formik}
        placeholder={t("fullAddress")}
        label={t("fullAddress")}
        name={"fullAddress"}
      />
      <TextInput
        formik={formik}
        placeholder={t("city")}
        label={t("city")}
        name={"city"}
      />
      <TextInput
        formik={formik}
        placeholder={t("phone")}
        label={t("phone")}
        name={"phone"}
      />
      <TextInput
        formik={formik}
        placeholder={t("email")}
        label={t("email")}
        name={"email"}
      />
      <TextInput
        formik={formik}
        placeholder={t("website")}
        label={t("websiteIfExists")}
        name={"website"}
      />
    </div>
  );
};

export default Step1Form;
